document.addEventListener("DOMContentLoaded", function () {
  const anonimityTrigger = document.querySelector('.js-whistleblowing-anonimity-trigger');
  const anonimityBlock = document.querySelector('.js-whistleblowing-anonimity-block');
  const hiddenClass = 'd-none';
  if (anonimityTrigger && anonimityBlock) {
    anonimityTrigger.addEventListener('change', function () {
      if (anonimityTrigger.checked) {
        anonimityBlock.classList.add(hiddenClass);
      } else {
        anonimityBlock.classList.remove(hiddenClass);
      }
    });
  }
});